<template>
  <div></div>
</template>

<script>
import { loginUtils } from '../../utils/auth'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  created () {
    let token = localStorageUtils.get('ssoToken') || ''
    loginUtils.ssoLogout(token)
  }
}
</script>

<style>

</style>
